import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {NotificationService} from "../../utils/notification.service";
import { I18nService } from '@app/shared/i18n/i18n.service';
import { I18nPipe } from '@app/shared/i18n/i18n.pipe';
import { AppState } from '@app/app.service';
import { CommonService } from '@app/shared/common/common.service';
// import { environment } from '@env/environment';

declare var $:any;

@Component({
  selector: 'sa-logout',
  template: `
    <div id="logout" (click)="showPopup()" class="btn-header transparent cursor-pointer">
        <span>
          <a routerlink="/auth/login" title="{{'commom_all_Logout_Logout' | i18n}}" data-action="userLogout"
                  data-logout-msg="You can improve your security further after logging out by closing this opened browser">
            <i class="fa fa-sign-out"></i>
          </a>
        </span>
    </div>
  `,
  styles: [],
  providers:[I18nPipe]
})
export class LogoutComponent implements OnInit {

  constructor(private router: Router,private notificationService: NotificationService, private i18nService: I18nService,private i18nPipe: I18nPipe,private _AppState:AppState,private commonService:CommonService) { }

  showPopup(){
    this.notificationService.smartMessageBox({
      title : `<i class='fa fa-sign-out theme-color-text'></i> 
        ${this.i18nService.getTranslation('commom_all_Logout_Logout')}
        <span class='txt-color-orangeDark'>
          <strong>${$('#show-shortcut').text()}</strong>
        </span> ?`,
      content : this.i18nService.getTranslation('commom_all_Logout_msg'),
      buttons : `[${this.i18nService.getTranslation('common_yes')}],[${this.i18nService.getTranslation('common_no')}]`
    }, (ButtonPressed) => {
      if (ButtonPressed == "Yes" || ButtonPressed == "Ja" || ButtonPressed == "Oui") {
        this.commonService.clearCookieStorage();
        this.commonService.logout();
      }
    });
  }

  // logout(){
  //   var formData = new FormData();
  //   formData.append("companyId", localStorage.getEncryptedItem('companyId'));
  //   formData.append('userId', localStorage.getEncryptedItem('loginId'));
  //   formData.append('appUserId', localStorage.getEncryptedItem('appUserId'));
  //   formData.append('action','Clear');
  //   formData.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
  //   formData.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
  //   let objectCount = this.commonService.createObject(formData)
  //   let tokenCount = this.commonService.createToken(objectCount)
  //   let encryptedTokenCount = this.commonService.encrypt(tokenCount)
  //   let encrDataCount = new FormData()
  //   encrDataCount.append("encrToken", encryptedTokenCount);
  //   this._AppState.clearLoginTime(encrDataCount).subscribe((data:any) => {
  //     if(!data.status && data.isUnauthenticated) {			
	// 			this.commonService.logout();
	// 			return false;
	// 		}
	// 		// localStorage.setEncryptedItem("lastRequestTime",data.RESPONSETIME);
  //     // localStorage.removeItem("loginId");
  //     // localStorage.removeEncryptedItem("loginId");
  //     // localStorage.removeEncryptedItem('currentlyWorkingIn');
  //     // localStorage.removeItem("lastVisitedModule");
  //     // localStorage.removeItem('sm-skin');
  //     // window.location.assign(window.location.origin);
  //     });
  //     localStorage.removeItem("loginId");
  //     localStorage.removeEncryptedItem("loginId");
  //     localStorage.removeEncryptedItem('currentlyWorkingIn');
  //     localStorage.removeItem("lastVisitedModule");
  //     this.clearCookieStorage();
  //     window.location.assign(window.location.origin);
  // }

  ngOnInit() {

  }

}
